
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import useState from '../../../hooks/useState';
import IServiceOrder from '../../../interfaces/IServiceOrder';
import DateField from '../../DateField';


interface IUpdateStartDateDialogProps extends IDefaultDialogProps {
    serviceOrder: IServiceOrder;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    startDate: Date | undefined;
}

const UpdateStartDateDialog: React.FC<IUpdateStartDateDialogProps> = ({
    open,
    handleClose,
    serviceOrder,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        startDate: undefined
    });


    useEffect(() => {
        if (open) {
            state.update('startDate', serviceOrder.startDate);
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('editStartDate')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <DateField
                        label={translate('startDate')}
                        format='DD/MM/YYYY'
                        name='startDate'
                        value={state.values.startDate}
                        onChange={value => state.update('startDate', value)}
                        disablePast={true}
                        required={false}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdateStartDateDialog;